'use client';

import { usePathname } from 'next/navigation';
import Head from 'next/head';
import JsonLd from './json-ld';

export default function SeoHead({
  title,
  description,
  image,
  type = 'website',
  jsonLdType = 'all',
  jsonLdData,
}) {
  const pathname = usePathname();

  // Default values
  const defaultTitle = 'X-SPACE Real Estate Dubai';
  const defaultDescription =
    'Your trusted partner in Dubai real estate, offering exceptional properties and personalized service.';
  const defaultImage = 'https://images.x-space.ae/assets/images/Logo-B.png';

  // Determine page-specific SEO content
  let pageTitle = title || defaultTitle;
  let pageDescription = description || defaultDescription;
  const pageImage = image || defaultImage;

  // Dynamically set SEO content based on the current page
  if (!title) {
    if (pathname === '/') {
      pageTitle = 'X-SPACE Real Estate Dubai | Luxury Properties in Dubai';
      pageDescription =
        'Find your dream property in Dubai with X-SPACE Real Estate. Luxury villas, apartments, and commercial properties in prime locations.';
    } else if (pathname === '/about') {
      pageTitle = 'About Us | X-SPACE Real Estate Dubai';
      pageDescription =
        'Learn about X-SPACE Real Estate, a leading real estate brokerage in Dubai with a commitment to excellence and customer satisfaction.';
    } else if (pathname.startsWith('/properties')) {
      pageTitle = 'Properties | X-SPACE Real Estate Dubai';
      pageDescription =
        'Explore our exclusive portfolio of properties in Dubai. Find luxury villas, apartments, and commercial spaces in prime locations.';
    } else if (pathname === '/contact-us') {
      pageTitle = 'Contact Us | X-SPACE Real Estate Dubai';
      pageDescription =
        'Get in touch with X-SPACE Real Estate. Our team of experts is ready to assist you with all your real estate needs in Dubai.';
    }
  }

  // Construct the canonical URL
  const baseUrl = 'https://x-space.ae';
  const canonicalUrl = `${baseUrl}${pathname}`;

  return (
    <>
      <Head>
        <title>{pageTitle}</title>
        <meta name='description' content={pageDescription} />
        <meta name='viewport' content='width=device-width, initial-scale=1' />
        <link rel='canonical' href={canonicalUrl} />

        {/* Open Graph / Facebook */}
        <meta property='og:type' content={type} />
        <meta property='og:url' content={canonicalUrl} />
        <meta property='og:title' content={pageTitle} />
        <meta property='og:description' content={pageDescription} />
        <meta property='og:image' content={pageImage} />

        {/* Twitter */}
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:url' content={canonicalUrl} />
        <meta property='twitter:title' content={pageTitle} />
        <meta property='twitter:description' content={pageDescription} />
        <meta property='twitter:image' content={pageImage} />

        <JsonLd type={jsonLdType} data={jsonLdData} url={canonicalUrl} />
      </Head>

      {/* JSON-LD Structured Data */}
    </>
  );
}
